import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {MaterialModule} from '../material/material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ServicesModule} from '../services/services.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {SharedElementsModule} from './shared/sharedElements.module';
import {ResourcesModule} from '../resources/resources.module';

@NgModule({
  imports: [
    SharedElementsModule,
    ResourcesModule,
    ServicesModule,
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    DashboardModule
  ],
  declarations: [LoginComponent]
})
export class PagesModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/pages.module.ts